export const EstadoSolicituPersonal=Object.freeze({
    PENDIENTE:"PENDIENTE",
    INICIADO:"INICIADO",
    RECHAZADO:"RECHAZADO",
    CERRADO:"CERRADO",
})